export const currencyFormat = {
  style: "currency",
  currency: "BRL"
};

export const formatPreciseCurrency = value =>
  `R$ ${value.toFixed(3).replace(".", ",")}`;

export const formatBalance = valueInCents => {
  const valueInBRL = valueInCents / 100;
  const formatCurrency = new Intl.NumberFormat("pt-BR", currencyFormat);
  return formatCurrency.format(valueInBRL).replace(/R\$\s/, "");
};

export const formatFileName = name => {
  const nameSections = name.match(/(.*)(\.[0-9a-z]+)$/i);
  if (nameSections && nameSections.length > 2) {
    const clippedFileName =
      nameSections[0].length < 24
        ? name
        : nameSections[1].substr(0, 24) + "..." + nameSections[2];
    return clippedFileName;
  } else {
    return name.length < 24 ? name : name.substr(0, 24) + "...";
  }
};

export const formatCityName = municipio =>
  `${municipio.nome_municipio}, ${municipio.Estado.nome_estado}`
    .toLowerCase()
    .replace(/(^| )(\w)/g, s => s.toUpperCase());

export const formatCpfCnpj = document =>
  document.length === 11
    ? document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
    : document.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );

export const formatCarReceipt = value => {
  const raw = value
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase()
    .slice(0, 41);
  const uf = raw.slice(0, 2);
  const numero = raw.slice(2, 9);
  const hash = raw.slice(9, 41);
  return [uf, numero, hash].filter(Boolean).join("-");
};

export const formatPercent = valueInDecimal => {
  const formatPercent = new Intl.NumberFormat("pt-BR", {
     style: 'percent',
     minimumFractionDigits: 2,
     maximumFractionDigits: 2
  });
  return formatPercent.format(valueInDecimal);
};
